export default "__VITE_ASSET__gPkxkw1g__"